import React from 'react'
import cx from 'classnames'

import styles from './Button.module.scss'

const Button = ({
  children,
  onClick,
  mode,
  loading,
  disabled,
  rounded,
  color,
  size,
  className,
  id,
  name,
  type,
  tabIndex,
  rightIcon,
  leftIcon,
  ...rest
}) => {
  const buttonClass = cx([styles.button], [styles[color]], [styles[size]], className, {
    [styles.disabledButton]: disabled,
    [styles.outline]: mode === 'outline',
    [styles.contained]: mode === 'contained',
    [styles.link]: mode === 'link',
    [styles.loading]: loading,
    [styles.rounded]: rounded
  })

  return (
    <button
      type={type || 'button'}
      className={buttonClass}
      disabled={disabled}
      onClick={onClick}
      id={id}
      name={name}
      tabIndex={tabIndex}
      {...rest}
    >
      {leftIcon && <div style={{ width: 24 }}>{leftIcon}</div>}
      <div className={styles.text}>
        {children}
      </div>
      {rightIcon && rightIcon}
    </button>
  )
}

Button.defaultProps = {
  children: null,
  onClick: () => {},
  color: 'default',
  size: 'regular',
  mode: 'contained',
  rounded: false,
  loading: false,
  disabled: false,
  className: null,
  leftIcon: null,
  rightIcon: null,
  id: null,
  name: null,
  tabIndex: null,
  type: 'button'
}
export default Button
